/* VIPet Store — testimonials carousel.
   Endless loop in both directions: drifts slowly and continuously, speeds up
   while an arrow is hovered, and never reaches an end.

   How the loop works: the slides are duplicated once. When the scroll passes
   the width of the original set we jump back by exactly that width. The jump
   is invisible because the content at both positions is identical.

   Two site-specific details this has to handle:
   1. The track has CSS scroll-behavior: smooth, which swallows per-frame
      scrollLeft writes. We force 'auto' on the element; the section's own
      arrow clicks pass behavior:'smooth' explicitly, so they still animate.
   2. In RTL containers browsers disagree on the sign of scrollLeft
      (here it runs negative). We detect the convention at runtime. */
(function () {
  var BASE = 0.35; /* px per frame, ~21px/s */
  var FAST = 2.2;  /* px per frame while hovering an arrow, ~130px/s */

  function init() {
    var track = document.querySelector('.reviews-carousel-track');
    if (!track || track.dataset.vipetLoop) return;

    var slides = [].slice.call(track.querySelectorAll('.review-slide'));
    if (slides.length < 2) return;

    track.dataset.vipetLoop = '1';

    /* Duplicate the set so there is always content on both sides. */
    slides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.vipetClone = '1';
      track.appendChild(clone);
    });

    var firstClone = track.querySelector('[data-vipet-clone]');
    var setWidth = Math.abs(firstClone.offsetLeft - slides[0].offsetLeft);
    if (!setWidth) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    track.style.scrollBehavior = 'auto';

    var start = track.scrollLeft;
    track.scrollLeft = -1;
    var negative = track.scrollLeft < 0;
    track.scrollLeft = start;

    var advance = negative ? -1 : 1;
    var dir = advance;
    var speed = BASE;
    var boostDir = 0;
    var pos = track.scrollLeft;
    var running = true;

    function boost(d) {
      return function () { speed = FAST; boostDir = d; };
    }
    function unboost() { speed = BASE; boostDir = 0; }

    var next = document.querySelector('.next-arrow');
    var prev = document.querySelector('.prev-arrow');
    if (next) {
      next.addEventListener('mouseenter', boost(advance));
      next.addEventListener('mouseleave', unboost);
    }
    if (prev) {
      prev.addEventListener('mouseenter', boost(-advance));
      prev.addEventListener('mouseleave', unboost);
    }

    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) { pos = track.scrollLeft; }
    });

    function wrap(p) {
      if (negative) {
        while (p <= -setWidth) { p += setWidth; }
        while (p > 0) { p -= setWidth; }
      } else {
        while (p >= setWidth) { p -= setWidth; }
        while (p < 0) { p += setWidth; }
      }
      return p;
    }

    function frame() {
      if (running) {
        pos = wrap(pos + (boostDir || dir) * speed);
        track.scrollLeft = pos;
      }
      window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
